module.exports = __webpack_public_path__ + "static/Unbounded-Medium-4D-56479ce9ce24cf83d67bc4e88cf2cfbd.woff2";